'use strict';

module.exports = {
    API_URL: 'https://api.mapbox.com',
    REQUIRE_ACCESS_TOKEN: true
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/mapbox-gl/js/util/config.js
 ** module id = 410
 ** module chunks = 0
 **/